export default {
  methods: {
    getTableClasses(columns, type, prefix = '') {
      return columns.reduce((acc, column) => ({
        ...acc,
        [column]: this.b(`${prefix}${type}-${column}`),
      }), { [`${type}Item`]: this.b(`${prefix}${type}-item`) });
    },
  },
};
